"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomNet = exports.MainNet = exports.FutureNet = exports.TestNet = exports.NetworksList = void 0;
var NetworksList;
(function (NetworksList) {
    NetworksList["testnet"] = "testnet";
    NetworksList["futurenet"] = "futurenet";
    NetworksList["mainnet"] = "mainnet";
    NetworksList["custom"] = "custom";
})(NetworksList || (exports.NetworksList = NetworksList = {}));
const TestNet = () => {
    return {
        name: NetworksList.testnet,
        networkPassphrase: 'Test SDF Network ; September 2015',
        rpcUrl: 'https://soroban-testnet.stellar.org:443',
        friendbotUrl: 'https://friendbot.stellar.org',
        horizonUrl: 'https://horizon-testnet.stellar.org',
        allowHttp: false,
    };
};
exports.TestNet = TestNet;
const FutureNet = () => {
    return {
        name: NetworksList.futurenet,
        networkPassphrase: 'Test SDF Future Network ; October 2022',
        rpcUrl: 'https://rpc-futurenet.stellar.org:443',
        friendbotUrl: 'https://friendbot-futurenet.stellar.org',
        horizonUrl: 'https://horizon-futurenet.stellar.org',
        allowHttp: false,
    };
};
exports.FutureNet = FutureNet;
const MainNet = () => {
    return {
        name: NetworksList.mainnet,
        networkPassphrase: 'Public Global Stellar Network ; September 2015',
        rpcUrl: '',
        horizonUrl: 'https://horizon.stellar.org',
        allowHttp: false,
    };
};
exports.MainNet = MainNet;
const CustomNet = (payload) => {
    return Object.assign({ name: NetworksList.custom }, payload);
};
exports.CustomNet = CustomNet;
